import {
  HTTP_GETFORECASTLIST2_FETCHING,
  HTTP_GETFORECASTLIST2_SUCCESS,
  HTTP_GETFORECASTLIST2_FAILED,
  HTTP_RESET_FORECASTLIST2,
  server,
} from "././../../Constants";
import { httpClient } from "././../../utils/HttpClient";

export const setStateGetForecastToFetching2 = () => ({
  type: HTTP_GETFORECASTLIST2_FETCHING,
});

export const setStateGetForecastToSuccess2 = (payload) => ({
  type: HTTP_GETFORECASTLIST2_SUCCESS,
  payload,
});

export const setStateGetForecastToFailed2 = (payload) => ({
  type: HTTP_GETFORECASTLIST2_FAILED,
});

export const clearForecast2 = () => {
  return (dispatch) => {
    dispatch({ type: HTTP_RESET_FORECASTLIST2 });
  };
};
export const getForecast2 = (
  countryid,
  companyid,
  brandid,
  departmentid,
  yearcode,
  yearid
) => {
  return async (dispatch) => {
    dispatch(setStateGetForecastToFetching2());
    try {
      const result = await httpClient.get(
        `${server.GETFORECAST2_URL}/${countryid}/${companyid}/${brandid}/${departmentid}/${yearcode}/${yearid}`
      );

      dispatch(setStateGetForecastToSuccess2(result.data));

      return Promise.resolve(result.data.length);
    } catch (error) {
      dispatch(setStateGetForecastToFailed2());
      return Promise.reject(error.message);
    }
  };
};
